const NUMBER_SELECTABLE_COUNTRY = 3;
const DEFAULT_SELECT_COUNTRY_OPTION = { label: 'Add a country', value: '' };

export { NUMBER_SELECTABLE_COUNTRY, DEFAULT_SELECT_COUNTRY_OPTION };



// WEBPACK FOOTER //
// ./app/constants/compare.js